export default {
  cooperativa: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  agenciaPA: {
    value: '',
    maxlength: '10',
    required: false,
    state: null
  },
  emailInterno: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/contacts/internal/components/add/ci-form.js